import academyCardImage from '@/public/images/blog/academy-card.png';
import communityCardImage from '@/public/images/blog/community-card.png';
import documentationCardImage from '@/public/images/blog/documentation-card.png';
import writeCardImage from '@/public/images/blog/write-card.png';

export const resourceCards = [
  {
    href: `/academy`,
    cta: `Learn more`,
    title: `Academy`,
    description: `Learn the basics about Headless CMS, GraphQL, DXP and more.`,
    color: `bg-indigo-rainbow hover:bg-zodiac`,
    image: academyCardImage,
  },
  {
    href: `/community`,
    cta: `Check them out`,
    title: `Community`,
    description: `See what the GraphCMS community is building and share your own.`,
    color: `bg-pink-600 hover:bg-pink-700`,
    image: communityCardImage,
  },
  {
    href: `/docs`,
    cta: `Explore Docs`,
    title: `Documentation`,
    description: `Get started with your project with our API and SDK documentation.`,
    color: `bg-green-600 hover:bg-green-700`,
    image: documentationCardImage,
  },
  {
    href: `/write-for-graphcms`,
    cta: `Create content`,
    title: `Write for GraphCMS`,
    description: `Share your technical expertise and help other developers learn.`,
    color: `bg-spanish-yellow hover:bg-yellow-600`,
    image: writeCardImage,
  },
];
